/**
 * Setup debug messaging on window level.
 * debug package used {@link https://www.npmjs.com/package/debug}
 * Enabling in browsers via set `debug` property in localStorage or passing process.env.DEBUG
 *
 * Considered remove prod/dev conditional enabling debug, due to for the moment
 * debug package itself and debug messages, all together adds less than 1% to bundle size.
 */

self.debug = function(){
  return Function.prototype;
/*
  const label = ['MggEmbed', ...arguments].join(':');

  return function(){
    console && console.log && console.log(label, ...arguments);
  }
*/
};

if (process.env.NODE_ENV !== 'production') {
  const _debug = require('debug');

  /*
    Monkey patch original debug, include trace into output
   */
  if (console && console.trace && console.groupCollapsed) {
    _debug.log = function(...args) {
      console.groupCollapsed(...args);
      console.trace();
      console.groupEnd();
    };
  }

  self.debug = (...debugIds) => {
    const logName = ['MggEmbed', ...debugIds].filter(Boolean).join(':');
    return _debug(logName);
  };
}